import React from 'react';
import { CDN_BASE_URL } from '../Utils/constant';

const logoStyle = {
  marginTop: '1rem',
  backgroundColor: 'white',
  width: '90%',
};

export default function CommonLogo() {
  return (
    <img 
      src={CDN_BASE_URL + '/assets/sg-banner.svg'} 
      alt="Sarvagram Logo" 
      style={logoStyle}
    />
  );
}

